<div class="wrapper warning" *ngIf="showBanner">
    <div class="inner-wrapper">
        <div
            aria-live="assertive"
            [innerHtml]="downtime.message | safeHtml"></div>
    </div>
</div>
